module.exports = __webpack_public_path__ + "static/media/addon-thumb.34a345ef.png";